export default __webpack_public_path__ + "ce7b354.png";